var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _HznRadio_emit;
import { LitElement } from '@horizon/base';
import { property } from '@horizon/base/decorators.js';
import { eventEmitter } from '@horizon/common/events';
/**
 *
 * @tag hzn-radio
 * @tagname hzn-radio
 * @summary A single radio input element for use in hzn-radios
 */
export class HznRadio extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * @private
         */
        _HznRadio_emit.set(this, eventEmitter(this));
        /**
         * Set the value for this radio button
         */
        this.value = '';
        /**
         * Set the help text for this radio
         */
        this.helperText = '';
        /**
         * Set the radio to be checked
         */
        this.checked = false;
    }
    connectedCallback() {
        super.connectedCallback();
        __classPrivateFieldGet(this, _HznRadio_emit, "f").call(this, { type: 'slotchange' });
    }
    /**
     * @private
     */
    updated() {
        __classPrivateFieldGet(this, _HznRadio_emit, "f").call(this, { type: 'slotchange' });
    }
}
_HznRadio_emit = new WeakMap();
__decorate([
    property({ type: String })
], HznRadio.prototype, "value", void 0);
__decorate([
    property({ type: String, attribute: 'helper-text' })
], HznRadio.prototype, "helperText", void 0);
__decorate([
    property({ type: Boolean })
], HznRadio.prototype, "checked", void 0);
//# sourceMappingURL=radio.js.map